import { browserDefaultTimezone } from "@simplyk/common";

import { useCurrentUserContext } from "@/common/contexts/CurrentUserContext";
import { trpc } from "@/common/helpers/trpc";

const CARD_VOLUME_STALE_TIME_MS = 10 * 60 * 1000;

export const useCardVolume = ({ enabled = true }: { enabled?: boolean } = {}) => {
  const { organization } = useCurrentUserContext();

  return trpc.getCardVolume.useQuery(
    {
      organizationId: organization?.id ?? "",
      timezone: browserDefaultTimezone,
    },
    {
      enabled: enabled && Boolean(organization?.id),
      staleTime: CARD_VOLUME_STALE_TIME_MS,
    }
  );
};
